import axios from 'axios';

axios.defaults.withCredentials = true;

const API_URL = process.env.REACT_APP_API_URL;

const submitNhapThongTin = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/nhap-thong-tin`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }, // Đảm bảo gửi dữ liệu dạng form-data
        });
        return response; // Trả về thông báo từ server
    } catch (error) {
        console.error('Error submitting data:', error);
        throw new Error('Không thể lưu dữ liệu nhập thông tin. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

const getUserData = async (search = null) => {
    try {
        const queryParam = search ? `?search=${search}` : '';
        const response = await axios.get(`${API_URL}/get_user_data${queryParam}`);
        return response.data;  // Trả về dữ liệu từ backend
    } catch (error) {
        console.error('Error fetching user data:', error);
        throw new Error('Không thể lấy dữ liệu người dùng. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

const saveUserData = async (initialData, updatedData, search = null) => {
    try {
        const queryParam = search ? `?search=${search}` : '';
        const response = await axios.post(`${API_URL}/save_user_data${queryParam}`, {
            initialData,
            updatedData,
        });
        return response.data;  // Trả về thông điệp thành công hoặc thất bại
    } catch (error) {
        console.error('Error saving user data:', error);
        throw new Error('Không thể lưu dữ liệu người dùng');
    }
};

// Hàm cập nhật thông tin đã nhập của tài xế (PUT)
const capNhatThongTinDaNhap = async (data) => {
    try {
        const response = await axios.put(`${API_URL}/cap_nhat_thong_tin_da_nhap_tai_xe`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;  // Trả về phản hồi từ API
    } catch (error) {
        console.error("Error during cap nhat thong tin da nhap:", error);
        throw error;
    }
};

// Hàm xóa thông tin đã nhập của tài xế (DELETE)
const xoaThongTinDaNhap = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/xoa_thong_tin_da_nhap_tai_xe`, {
            params: { id: id },
        });
        return response.data;  // Trả về phản hồi từ API
    } catch (error) {
        console.error("Error during xoa thong tin da nhap:", error);
        throw error;
    }
};

// Hàm nhận chuyến
const nhanChuyen = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/nhan_chuyen`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error during nhan chuyen:", error);
        throw error;
    }
};

// Hàm cập nhật chuyến
const capNhatChuyen = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/capnhat_chuyen`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error during cap nhat chuyen:", error);
        throw error;
    }
};

// Hàm kết thúc chuyến
const ketThucChuyen = async (formData) => {
    try {
        console.log(formData)
        const response = await axios.post(`${API_URL}/ketthuc_chuyen`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error during ket thuc chuyen:", error);
        throw error;
    }
};

// API mới: Hàm hoàn thành chuyến
const hoanThanhChuyen = async (maChuyen) => {
    try {
        const formData = new FormData();
        formData.append('ma_chuyen', maChuyen);
        const response = await axios.post(`${API_URL}/hoan_thanh_chuyen`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error("Error during hoan thanh chuyen:", error);
        throw error;
    }
};

// API mới: Hàm nhập Km phát sinh
const nhapKmPhatSinh = async (kmPhatSinh, timeVeKho, maChuyen) => {
    try {
        const formData = new FormData();
        formData.append('ma_chuyen', maChuyen);
        formData.append('thoi_gian_ve_kho', timeVeKho);
        const response = await axios.post(`${API_URL}/nhap_km_phat_sinh/${kmPhatSinh}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error("Error during nhap Km phat sinh:", error);
        throw error;
    }
};

// Hàm gọi đến API load chuyến kinh doanh tài xế hiện tại
const loadChuyenKdTaiXeHT = async () => {
    try {
        const response = await axios.get(`${API_URL}/load_chuyen_kd_tai_xe_ht`);
        return response.data;  // Trả về dữ liệu từ API
    } catch (error) {
        console.error('Error loading chuyen kd tai xe:', error);
        throw new Error('Không thể tải dữ liệu chuyến kinh doanh tài xế. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

// Hàm cập nhật km chuyến kinh doanh
const capNhatKmKinhDoanh = async (data) => {
    try {
        const response = await axios.post(`${API_URL}/cap_nhat_km_kinh_doanh`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;  // Trả về phản hồi từ API
    } catch (error) {
        console.error("Error updating km kinh doanh:", error);
        throw new Error('Không thể cập nhật km kinh doanh. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
}

const submitNhapChuyenBuuChinh = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/nhap_chuyen_buu_chinh`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }, // Đảm bảo gửi dữ liệu dạng form-data
        });
        return response; // Trả về thông báo từ server
    } catch (error) {
        console.error('Error submitting data:', error);
        throw new Error('Không thể lưu dữ liệu nhập thông tin. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

const getMaChuyenNOC = async () => {
    try {
      const response = await axios.get(`${API_URL}/ma_chuyen_noc_gan_day`);
      return response.data;
    } catch (error) {
      console.error("Error fetching chuyen kinh doanh:", error);
      throw new Error('Không thể lấy dữ liệu người dùng. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
  };


//Lấy danh sách chuyến bảo dưỡng được giao cho tài xế
const getAllChuyenBaoduong = async () => {
    try {
        const username = localStorage.getItem("username");

        if (!username) {
            throw new Error("Không tìm thấy username. Vui lòng đăng nhập lại.");
        }

        const response = await axios.get(`${API_URL}/allchuyenbaoduong`, {
            params: { username } 
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching chuyen kinh doanh:", error);
        throw new Error('Không thể lấy dữ liệu người dùng. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

// Cập nhật trạng thái phân công bảo dưỡng sửa chữa xe
const updateBdSc = async (id, vai_tro, trang_thai) => {
    try {
        const username = localStorage.getItem("username");

        if (!username) {
            throw new Error("Không tìm thấy username. Vui lòng đăng nhập lại.");
        }

        const response = await axios.post(`${API_URL}/tx_update_bd_sc`, {
            username, id, vai_tro, trang_thai // Gửi dữ liệu trong body
        });

        return response.data; // Trả về thông báo từ server
    } catch (error) {
        console.error("Error submitting data:", error.response?.data || error.message);
        throw new Error("Không thể lưu dữ liệu. Vui lòng đăng xuất, đăng nhập và thử lại.");
    }
};

// Hàm gọi đến API load chuyến kinh doanh tài xế hiện tại
const load_thong_tin_chuyen_cua_lai_xe = async (startDay, endDay) => {
    try {
        const params = {
            start_day: startDay,
            end_day: endDay,
        };

        const response = await axios.get(`${API_URL}/load_thong_tin_chuyen_cua_lai_xe`, {
            params
        });
        return response.data; // Trả về dữ liệu JSON
    } catch (error) {
        console.error('Lỗi khi lấy dữ liệu thô KD:', error);
        throw new Error('Không thể lấy dữ liệu thô KD.');
    }
};

// Hàm để gán thêm thông tin (biển kiểm soát và tài xế) cho một chuyến xe
const ganBuuTa = async (maChuyen, formData) => {
    try {
        const response = await axios.post(`${API_URL}/gan_buu_ta/${maChuyen}`, formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, // Gửi dữ liệu dạng form URL-encoded
        });

        return response.data; // Trả về dữ liệu từ server (thành công hoặc lỗi)
    } catch (error) {
        console.error(`Error assigning info to trip ${maChuyen}:`, error);
        throw new Error('Không thể gán thêm thông tin cho chuyến xe.');
    }
};

// Hàm để lấy thông tin Bưu tá cho một chuyến xe
const getBuuTa = async (maChuyen) => {
    try {
        // Sử dụng phương thức GET thay vì POST
        const response = await axios.get(`${API_URL}/get_buu_ta/${maChuyen}`);
        return response; // Trả về dữ liệu JSON từ server (success hoặc error)
    } catch (error) {
        console.error(`Error getting Bưu tá info for trip ${maChuyen}:`, error);
        throw new Error('Không thể lấy thông tin Bưu tá cho chuyến xe.');
    }
};

// Đặt tên cho object trước khi export
const DriverService = {
    getUserData,
    capNhatThongTinDaNhap,
    xoaThongTinDaNhap,
    saveUserData,
    submitNhapThongTin,
    nhanChuyen,
    capNhatChuyen,
    ketThucChuyen,
    hoanThanhChuyen,    // Thêm API hoàn thành chuyến
    nhapKmPhatSinh,     // Thêm API nhập Km phát sinh
    loadChuyenKdTaiXeHT, // Thêm API load chuyến kd tài xế hiện tại
    capNhatKmKinhDoanh,
    submitNhapChuyenBuuChinh,
    getMaChuyenNOC,
    getAllChuyenBaoduong,
    updateBdSc,
    load_thong_tin_chuyen_cua_lai_xe,
    ganBuuTa,
    getBuuTa,
};

export default DriverService;
